import React, { useEffect, useState } from 'react'

import Panel from '../../../../components/structure/Panel'
import Separator from '../../../../components/helpers/Separator'
import DynamicServiceOrderDetailsPanel from './sections/DynamicServiceOrderDetailsPanel'
import DynamicServiceOrdersPlaceDetailsPanel from './sections/DynamicServiceOrdersPlaceDetailsPanel'
import { useDynamicServiceOrders } from '../_load/DynamicServiceOrdersLoader'

const GeneralPanel = () => {
  const { place } = useDynamicServiceOrders()
  const { asset } = useDynamicServiceOrders()
  const [shouldSelectPlace, setShouldSelectPlace] = useState()

  useEffect(() => {
    setShouldSelectPlace(!place)
  }, [])

  return (
    <div>
      <Panel smallPadding noMargin lineBorder>
        <DynamicServiceOrderDetailsPanel />
        {!asset && shouldSelectPlace && <DynamicServiceOrdersPlaceDetailsPanel />}
      </Panel>
      <Separator weight={4} />
    </div>
  )
}

export default GeneralPanel
